import React, { useEffect, useState } from "react";
import { Card, Grid, IconButton } from "@mui/material";
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel";

import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import MatchGameCard from "./component/matchesCard";
import LeaderBoard from "./component/leaderboard";
import { getWebTournamentBestOf, getWebTournamentPool } from "services/tournamentServices";

function CategoryPool ({
    tournamentId,
    category
}) {

    const [ pool, setPool ] = useState([])
    const [ bestOf, setBestOf ] = useState(null)
    
    useEffect(() => {
        setPool([])
        setBestOf(null)
        loadPool()
    }, [category])

    useEffect(() => {
        console.log('here pool', pool)
        if (pool.length > 0) { loadBestOf() }
    }, [pool])

    const reload = async (e) => {
        const idStr = String(e?.poolId);
        if (e) {
            setPool(prev => {
                // update isFavourite flag for the specific pool
                const updated = prev.map(p =>
                    String(p._id) === idStr ? { ...p, isFavourite: !!e.favourite } : p
                );

                if (e.favourite) {
                    // pin to front
                    const first = updated.find(p => String(p._id) === idStr);
                    const rest  = updated.filter(p => String(p._id) !== idStr);
                    return [first, ...rest];
                }

                // unfav: keep alphabetical (A→Z)
                return [...updated].sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? ''));
            });
        }
        await loadPool()
    };

    const loadPool = async () => {
        let { data, error } = await getWebTournamentPool({
            tournamentId,
            tournamentDetailCategoryId: category
        })
        console.log('here pool loadPool', data, pool)
        if (data) { setPool([...data]) }
    }

    const loadBestOf = async () => {
        // let { data, error } = await getWebTournamentBestOf({
        //     tournamentId,
        //     tournamentDetailCategoryId: category
        // })
        // console.log('here bestOfPool bestOfPool', data)
        // if (data && data._id) { setBestOf(data) }
    }

    return (
        <>
        {
            pool.map(v => {
                return (
                    <PoolInfo key={v._id} v={v} reload={(e) => {reload(e)}}/>
                )
            })
        }
        {
            bestOf && <PoolInfo key={bestOf._id} v={bestOf} reload={() => {}} />
        }
        </>
    )
}

function PoolInfo ({
    v, reload
}) {
    const [ fav, setFav ] = useState(v.isFavourite)
    const [ isLoading, setLoading ] = useState(false)

    useEffect(() => {
        setFav(!!v.isFavourite);
    }, [v.isFavourite?._id, v.isFavourite]); // covers both create/remove

    const updateFav = async (e) => {
        try {
            console.log('here fav', fav)
            setFav(!fav)
            // let { data, error } = await updateFavourite({
            //     tournamentId: v.tournamentId, 
            //     poolId: v._id, 
            //     bracketId: null, 
            //     favouriteId: v.isFavourite?._id, 
            //     favourite: !fav
            // })
            reload({
                poolId: v._id, 
                favourite: !fav
            })
        } catch (error) {
            console.log('here error', error)
        }
    }

    return (
        <Grid mt={0.5}>
            <Card sx={{ position: 'relative', minHeight: 60}}>
                <Grid item sx={{
                    position: "absolute",
                    left: 8,
                    bgcolor: "background.paper",
                    display: 'flex',
                    alignItems: 'center',
                    // boxShadow: 1,
                    "&:hover": { bgcolor: "background.paper" }
                }}>
                    {/* {
                        v.name && 
                        <IconButton
                            aria-label="favorite"
                            onClick={() => updateFav()}
                            size="small"
                        >
                            {fav ? <StarIcon sx={{
                                color: 'gold'
                            }} /> : <StarBorderIcon />}
                        </IconButton>
                    } */}
                    <TCLabel bold ml={1}>{v.name ? v.name : v.bestOf ? v.bestOf == "runner_up" ? "Best of Runner-up" : "Best of Third Place" : ''}</TCLabel>
                </Grid>
                {
                    v.matches?.length == 0 &&
                    <Grid container xs={12} sx={{minHeight: 18}}></Grid>
                }
                {
                    v.matches?.length > 0 &&
                    <Grid container xs={12} sx={{ minHeight: 40 }}>
                        <div className="scrollableContainer" style={{
                            overflowX: 'auto',
                            display: 'flex',
                            // gap: 8,
                            marginTop: 26,
                            paddingBottom: 8, paddingLeft: 16, paddingRight: 16
                        }}
                        // ref={scrollRef}
                        >    
                            {/* Match list */}
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "nowrap",    // ⬅️ no wrapping
                                    gap: 8,                // optional spacing
                                }}
                                >
                                {
                                    v.matches && v.matches.map(match => {
                                        console.log('here match Info', match)
                                        return (
                                            <div style={{
                                                maxWidth: '200px'
                                            }}>
                                                <MatchGameCard 
                                                    // form={form} isResult={form.isResult} isDragging={isDragging} 
                                                    match={match} isEdited={match.isEdited} 
                                                    loadMatchInfo={() => reload()} 
                                                    loadInfoOnly={() => { reload() }} 
                                                    setLoading={setLoading}
                                                />
                                            </div>
                                        )
                                    })
                                }    
                            </div> 
                        </div>                 
                    </Grid>
                }
                <Grid container xs={12} p={2} pb={0} pt={0.2}>
                    <LeaderBoard leaderBoard={v.seeds} allowShowConfetti={false} tournamentCard={true} isWrap={v.isWrap}/>
                </Grid>
            </Card>
        </Grid>
    )
}

export default CategoryPool